import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";

type AmplitudeOfferSourceProperty = IPropertyListItemDTO | IPropertyDetailDTO;

export const isAmplitudeRpOffer = (property: AmplitudeOfferSourceProperty): boolean => {
    return Boolean(property.rp_id);
};

export const getAmplitudeOfferSourceProperties = (property: AmplitudeOfferSourceProperty) => {
    const offerUrl = "url" in property ? property.url : null;

    if (!isAmplitudeRpOffer(property)) {
        return {
            external_source: null,
            offer_source: "external" as const,
            offer_url: offerUrl || null
        };
    }

    return {
        external_source: null,
        offer_source: "rp" as const,
        offer_url: null
    };
};
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";

type AmplitudeOfferSourceProperty = IPropertyListItemDTO | IPropertyDetailDTO;

export const isAmplitudeRpOffer = (property: AmplitudeOfferSourceProperty): boolean => {
    return Boolean(property.rp_id);
};

export const getAmplitudeOfferSourceProperties = (property: AmplitudeOfferSourceProperty) => {
    const offerUrl = "url" in property ? property.url : null;

    if (!isAmplitudeRpOffer(property)) {
        return {
            external_source: null,
            offer_source: "external" as const,
            offer_url: offerUrl || null
        };
    }

    return {
        external_source: null,
        offer_source: "rp" as const,
        offer_url: null
    };
};
